import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyConversionService } from '../../../../Core/Users/services/currency-conversion.service';
import { UserCurrency } from '../../../../Core/Users/enums/user-currency';
@Pipe({
    name: 'AppendCurrencyCode',
    standalone: false
})

export class AppendCurrencyCodePipe implements PipeTransform {
    constructor(
        private conversionService: CurrencyConversionService
    ) { }

    transform(value: any, target?: UserCurrency) {
        return this.conversionService.appendCurrencyCode(value, target);
    }

}
